import { MapTo } from '@adobe/aem-react-editable-components';
import ProductPageHero, { ProductPageHeroEditConfig } from './ProductPageHero';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-page-hero')(ProductPageHero, ProductPageHeroEditConfig);